import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { createServiceControll } from "../../../../services/ServiceControllService";
import { toast } from "react-toastify";
import Select from "react-select";
import { findByLicensePlate } from "../../../../services/CarService";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import carBrands from "../../../../consts/CarBrands";
import Spinner from "../../../../components/Spinner";
import CadastrarServicoModal from "./CadastrarServicoModal";
import CadastrarClienteVeiculoModal from "./CadastrarClienteVeiculoModal";
import { findLastQuotationByCustomerId } from "../../../../services/QuotationService";
import { maskPhone } from "../../../../util/StringUtils";

export const ControleServicoModal = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [searchingCar, setSearchingCar] = useState(false);
  const [selectedServies, setSelectedServies] = useState([]);
  const [selectedParts, setSelectedsParts] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState();

  const [licensePlate, setLicensePlate] = useState("");
  const [vehicleColor, setVehicleColor] = useState(null);
  const [vehicleModel, setVehicleModel] = useState(null);
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [inputSignValue, setInputSignValue] = useState(null);
  const [inputCheckList, setInputCheckList] = useState(null);
  const [inputVehicleModelDisabled, setInputVehicleModelDisabled] = useState(false);
  const [inputSelectCustomerDisabled, setInputSelectCustomerDisabled] = useState(false);
  const [inputVehicleColorDisabled, setInputVehicleColorDisabled] = useState(false);

  const licensePlateRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [modalServicoOpen, setModalServicoOpen] = useState(false);
  const [modalCadastroCliente, setModalCadastroCliente] = useState(false);
  const [vehicleBrand, setVehicleBrand] = useState();
  const [brandSelectDisabled, setBrandSelectDisabled] = useState(false);
  const [quotationId, setQuotationId] = useState();
  const [disableSelectCustomer, setDisableSelectCustomer] = useState(false);

  let confirmedQuotation = false;

  useEffect(() => {
    if (props.selectedSchedule && props.selectedSchedule.licensePlate) {
      findVehicle(props.selectedSchedule.licensePlate);
      setSelectedServies(
        props.services.filter((s) =>
          props.selectedSchedule.servicesIds.includes(s.value),
        ),
      );
    }
  }, []);

  const toggle = () => {
    props.setOpenControleServicoModal(false);
    props.setSelectedSchedule();
  };

  function handleChangeCustomer(customer) {
    setSelectedCustomer(customer);
    if (customer) {
      //Desabilitado por disparar onblur da plca do veiculo
      //findQuotation(customer.value);
    } else {
      setSelectedServies([]);
      setLicensePlate(null);
    }
  }

  function findQuotation(customerId) {
    if (!confirmedQuotation) {
      findLastQuotationByCustomerId(customerId)
        .then((response) => {
          if (response) {
            const execute = window.confirm(
              "Preencher com os serviços do orçamento do cliente?",
            );
            if (execute) {
              confirmedQuotation = true;
              findVehicle(response.vehiclePlate);

              const validServices = response.servicesIds
                .map((serviceId) => props.services.find((service) => service.value === serviceId))
                .filter((service) => service !== undefined);

              setSelectedServies(validServices);
              setQuotationId(response.id);
              toast.success(
                "Serviços preenchidos com as informações do orçamento",
              );
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  function findVehicle(licensePlate) {
    findByLicensePlate(licensePlate)
      .then((response) => {
        if (response) {
          setSearchingCar(false);
          setLicensePlate(response.licensePlate);
          setVehicleColor(response.color);
          setVehicleModel(response.model);

          setVehicleBrand({
            key: response.brand,
            label: response.brand.replace("_", " "),
            value: response.brand.replace("_", " "),
          });

          if (response.customer) {
            setSelectedCustomer({
              value: response.customer.id,
              label:
                response.customer.name +
                " " +
                maskPhone(response.customer.phone.substring(2)),
            });
            setDisableSelectCustomer(true);
            findQuotation(response.customer.id);
          } else {
            setDisableSelectCustomer(false);
            setSelectedCustomer(null);
          }

          setBrandSelectDisabled(true);
          setVehicleColor(response.color);
          setInputVehicleModelDisabled(true);
          setInputVehicleColorDisabled(true);
          setInputSelectCustomerDisabled(true);
        } else {
          setSearchingCar(false);
          setLicensePlate(licensePlate);
          setInputVehicleColorDisabled(false);
          setInputVehicleModelDisabled(false);

          setVehicleColor(null);
          setVehicleModel(null);

          setVehicleBrand(null);
          setBrandSelectDisabled(false);
          setSelectedCustomer(null);
          setDisableSelectCustomer(false);
          setModalCadastroCliente(true);
        }
      })
      .catch((error) => {
        setSearchingCar(false);
        setVehicleBrand(null);
        setBrandSelectDisabled(false);
        setDisableSelectCustomer(false);
      });
  }

  function handleInputLicensePlate(e) {
    setLicensePlate(e.target.value.toUpperCase());
  }

  useEffect(() => {
    if (licensePlate && licensePlate.length === 7) {
      setSearchingCar(true);
      findVehicle(licensePlate);
    } else {
      setSearchingCar(false);
      setVehicleColor(null);
      setVehicleModel("");
      setVehicleColor("");
      setInputVehicleColorDisabled(false);
      setInputVehicleModelDisabled(false);
      setBrandSelectDisabled(false);
      setVehicleBrand(null);
      setSelectedCustomer(null);
      setDisableSelectCustomer(false);
    }
  }, [licensePlate]);

  const formatServicesLabels = (service) => (
    <>
      <span>{service.label}</span>
      <span> - R$ {service.key}</span>
    </>
  );

  const formatCustomersLabels = (customer) => (
    <>
      <span>{customer.label}</span>
    </>
  );

  function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();

    const data = {
      licensePlate,
      vehicleBrand: vehicleBrand.key,
      vehicleColor,
      vehicleModel,
      servicesIds: selectedServies.map((service) => service.value),
      partsIds: selectedParts.map((part) => part.value),
      userId: localStorage.getItem("userId"),
      employeeId: selectedEmployee.value,
      customerId: selectedCustomer ? selectedCustomer.value : null,
      signValue: 0,
      checklist: inputCheckList,
      quotationId,
      scheduleId: props.selectedSchedule
        ? props.selectedSchedule.event_id
        : null,
    };

    createServiceControll(data)
      .then((response) => {
        props.setOpenControleServicoModal(false);
        props.listControllServices(false);
        props.loadTodaySchedules();
        toast.success("Ordem de serviço criada");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        toast.error("Não foi possivel criar ordem de serviço");
      });
  }

  function calculateTotalSelectServices() {
    return currencyBRFormat(
      selectedServies
        .concat(selectedParts)
        .map((service) => service.key)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
    );
  }

  return (
    <div>
      <CadastrarServicoModal
        setModalServicoOpen={setModalServicoOpen}
        modalServicoOpen={modalServicoOpen}
        listServices={props.listServices}
      />

      {modalCadastroCliente && (
        <CadastrarClienteVeiculoModal
          setModalCadastroCliente={setModalCadastroCliente}
          open={modalCadastroCliente}
          licensePlate={licensePlate}
          listCustomers={props.listCustomers}
          findVehicle={findVehicle}
        />
      )}

      <Modal
        isOpen={isOpen}
        backdrop="static"
        size="lg"
        contentClassName="border-0 rounded-4 shadow-lg"
        onOpened={() => licensePlateRef.current?.focus()}
      >
        <ModalHeader className="no-select border-bottom-0 pb-0 pt-4 px-4" toggle={toggle}>
          <span className="fw-bold text-primary">Nova Ordem de Serviço</span>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="p-4">
            {/* SEÇÃO 1: VEÍCULO (O CORAÇÃO DO LAVA-JATO) */}
            <div className="bg-light p-3 rounded-4 border mb-4">
              <div className="d-flex align-items-center mb-3">
                <i className="fas fa-car me-2 text-primary"></i>
                <span className="fw-bold text-muted small text-uppercase">Dados do Veículo</span>
              </div>

              {searchingCar ? (
                <div className="text-center py-3"><Spinner /></div>
              ) : (
                <div className="row g-3">
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Placa <span className="text-danger">*</span></label>
                    <input
                      ref={licensePlateRef}
                      onChange={handleInputLicensePlate}
                      defaultValue={props.selectedSchedule?.licensePlate}
                      value={licensePlate}
                      type="text"
                      minLength={7}
                      maxLength={7}
                      className="form-control form-control-lg fw-bold text-uppercase border-2"
                      style={{ letterSpacing: '2px', backgroundColor: '#fff' }}
                      required
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Marca <span className="text-danger">*</span></label>
                    <Select
                      name="brands"
                      classNamePrefix="select"
                      onChange={(brand) => setVehicleBrand(brand)}
                      value={vehicleBrand}
                      options={carBrands.map((brand) => ({
                        value: brand.replace("_", " "),
                        key: brand,
                        label: brand.replace("_", " "),
                      }))}
                      placeholder="Marca..."
                      isDisabled={brandSelectDisabled}
                      required
                      styles={{ control: (b) => ({ ...b, borderRadius: '8px', minHeight: '48px' }) }}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label htmlFor="modeloCarro" className="form-label small fw-bold text-dark">Modelo <span className="text-danger">*</span></label>
                    <input
                      value={vehicleModel}
                      onChange={(e) => setVehicleModel(e.target.value)}
                      disabled={inputVehicleModelDisabled}
                      id="modeloCarro"
                      className="form-control form-control-lg fs-6"
                      required
                      placeholder="Ex: Golf"
                    />
                  </div>
                  <div className="col-lg-3">
                    <label htmlFor="corCarro" className="form-label small fw-bold text-dark">Cor</label>
                    <input
                      id="corCarro"
                      value={vehicleColor}
                      disabled={inputVehicleColorDisabled}
                      onChange={(e) => setVehicleColor(e.target.value)}
                      className="form-control form-control-lg fs-6"
                      placeholder="Preto..."
                    />
                  </div>
                </div>
              )}
            </div>

            {/* SEÇÃO 2: CLIENTE E RESPONSÁVEL */}
            <div className="row mb-4 g-3">
              <div className="col-lg-7">
                <div className="h-100 bg-white p-3 rounded-4 border shadow-sm">
                  <label className="form-label fw-bold text-muted small text-uppercase mb-2">
                    <i className="fas fa-user me-2"></i>Cliente
                  </label>
                  <Select
                    onChange={handleChangeCustomer}
                    id="customerSelect"
                    name="customers"
                    classNamePrefix="select"
                    value={selectedCustomer}
                    options={props.customers}
                    placeholder="Vincular a um cliente..."
                    isDisabled={disableSelectCustomer}
                    formatOptionLabel={formatCustomersLabels}
                    isClearable
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="h-100 bg-white p-3 rounded-4 border shadow-sm">
                  <label className="form-label fw-bold text-muted small text-uppercase mb-2">
                    <i className="fas fa-id-badge me-2"></i>Funcionário
                  </label>
                  <Select
                    onChange={(data) => setSelectedEmployee(data)}
                    id="listaUsuarios"
                    name="services"
                    classNamePrefix="select"
                    options={props.employees}
                    placeholder="Responsável..."
                    required
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                </div>
              </div>
            </div>

            {/* SEÇÃO 3: CHECKLIST E SERVIÇOS */}
            <div className="bg-light p-3 rounded-4 border mb-3">
              <div className="row g-4">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold text-muted small text-uppercase mb-0">Checklist</label>
                    <button
                      onClick={() => setInputCheckList("Veículo sem avarias ou detalhes")}
                      className="btn btn-sm btn-success rounded-pill px-3 fw-bold"
                      type="button"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <i className="fas fa-check me-1"></i> Sem Avarias
                    </button>
                  </div>
                  <textarea
                    onChange={(e) => setInputCheckList(e.target.value)}
                    value={inputCheckList}
                    className="form-control rounded-3 border-2"
                    rows="2"
                    placeholder="Ex: Risco na porta esquerda..."
                    required
                  />
                </div>

                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold text-muted small text-uppercase mb-0">Serviços a Realizar</label>
                    <button
                      onClick={() => setModalServicoOpen(true)}
                      type="button"
                      className="btn btn-sm btn-primary rounded-pill px-3 fw-bold"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Novo Serviço
                    </button>
                  </div>
                  <Select
                    onChange={(data) => setSelectedServies(data)}
                    id="listaServicos"
                    isMulti
                    name="services"
                    classNamePrefix="select"
                    value={selectedServies}
                    options={props.services}
                    formatOptionLabel={formatServicesLabels}
                    placeholder="Selecione os serviços..."
                    isClearable
                    required
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                  <div className="text-end mt-2">
                    <span className="text-muted small fw-bold text-uppercase me-2">Total:</span>
                    <span className="h5 fw-bold text-primary mb-0">{calculateTotalSelectServices()}</span>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="border-top-0 p-4 pt-0">
            {!loading ? (

              <div className="d-flex flex-column flex-sm-row w-100 gap-2">

                <button
                  type="submit"
                  className="btn btn-primary btn-lg fw-bold flex-grow-1 rounded-3 shadow-sm order-0"
                >
                  <i className="fas fa-file-invoice me-2"></i>
                  Gerar Ordem de Serviço
                </button>

                <button
                  type="button"
                  onClick={toggle}
                  className="btn btn-outline-danger btn-lg rounded-3 border-2 order-1"
                >
                  Cancelar
                </button>

              </div>
            ) : (
              <div className="w-100 text-center py-2">
                <Spinner color="primary" />
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default ControleServicoModal;
